import React from 'react';
import Image from 'next/image';

const ProductTypesContent = () => (
  <div className="product-types">
    <div className="product-category">
      <h3>Листовий прокат</h3>
      <div className="product-items">
        <div className="product-item">
          <Image src="/images/products/hot-rolled-sheet.jpg" alt="Гарячекатаний лист" width={300} height={200} />
          <h4>Гарячекатаний лист</h4>
          <p>Має шорстку поверхню, ідеальний для будівництва, зварювальних конструкцій.</p>
        </div>
        <div className="product-item">
          <Image src="/images/products/cold-rolled-sheet.jpg" alt="Холоднокатаний лист" width={300} height={200} />
          <h4>Холоднокатаний лист</h4>
          <p>Гладка поверхня, висока точність. Застосовується в автомобільній промисловості та виробництві побутової техніки.</p>
        </div>
      </div>
    </div>
    
    <div className="product-category">
      <h3>Сортовий прокат</h3>
      <div className="product-items">
        <div className="product-item">
          <Image src="/images/products/reinforcement.jpg" alt="Арматура" width={300} height={200} />
          <h4>Арматура</h4>
          <p>Необхідна для армування залізобетонних конструкцій.</p>
        </div>
        <div className="product-item">
          <Image src="/images/products/channel.jpg" alt="Швелер" width={300} height={200} />
          <h4>Швелер</h4>
          <p>П-подібний профіль для зміцнення каркасів.</p>
        </div>
        <div className="product-item">
          <Image src="/images/products/angle.jpg" alt="Кутик" width={300} height={200} />
          <h4>Кутик</h4>
          <p>Г-подібний профіль для з&apos;єднання елементів.</p>
        </div>
        <div className="product-item">
          <Image src="/images/products/i-beam.jpg" alt="Двутаврова балка" width={300} height={200} />
          <h4>Двутаврова балка</h4>
          <p>Висока міцність при відносно малій вазі.</p>
        </div>
      </div>
    </div>
    
    <div className="product-category">
      <h3>Трубний прокат</h3>
      <div className="product-items">
        <div className="product-item">
          <Image src="/images/products/water-gas-pipes.jpg" alt="Водогазопровідні труби" width={300} height={200} />
          <h4>Водогазопровідні труби</h4>
          <p>Для транспортування рідин і газів.</p>
        </div>
        <div className="product-item">
          <Image src="/images/products/profile-pipes.jpg" alt="Профільні труби" width={300} height={200} />
          <h4>Профільні труби</h4>
          <p>Квадратні та прямокутні для металоконструкцій.</p>
        </div>
        <div className="product-item">
          <Image src="/images/products/seamless-pipes.jpg" alt="Безшовні труби" width={300} height={200} />
          <h4>Безшовні труби</h4>
          <p>Витримують високий тиск, використовуються у складних умовах.</p>
        </div>
      </div>
    </div>
  </div>
);

export default ProductTypesContent; 